import { useState } from 'react';
import Container from '../ui/Container';
import InfoModal from '../ui/InfoModal';
import { missionVisionData } from './data/missionVisionData';
import MissionVisionCard from './MissionVisionCard';

export default function MissionVision() {
  const [selectedItem, setSelectedItem] = useState<'mission' | 'vision' | null>(null);

  return (
    <section className="py-16">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <MissionVisionCard
            title="Our Mission"
            description={missionVisionData.mission.short}
            onClick={() => setSelectedItem('mission')}
          />
          <MissionVisionCard
            title="Our Vision"
            description={missionVisionData.vision.short}
            onClick={() => setSelectedItem('vision')}
          />
        </div>

        <InfoModal
          isOpen={selectedItem !== null}
          onClose={() => setSelectedItem(null)}
          title={selectedItem === 'mission' ? 'Our Mission' : 'Our Vision'}
          content={selectedItem ? missionVisionData[selectedItem].full : ''}
        />
      </Container>
    </section>
  );
}